import { Button, Col, Form, Row, Select, Tooltip } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import commontStyles from './document.less'
import { SaveOutlined } from '@ant-design/icons'
import { connect, useDispatch } from 'react-redux'
import S3UploadMultiple from '../../../../../../Components/S3UploadMultiple'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'
import { SaveOfficerDocument } from '../../../../../../Services/Corporate'
import { customizeRequiredMark } from '../../../../../../Components/customizeRequiredMark'
import { GetSolderDropDownList } from '../../../../../../Services/Common'
import { type SolderServiceDocument } from '../../../../../../Types/Client/RegisteredClients/SoleTrader'

const ServiceDocumentUpload = (props: {
    soleTraderId: number
    companyAttachmentId: number | undefined
    serviceName: string | undefined
    documentBaseId: number | undefined
    documentType: string | undefined
    fetchData: () => void
    pensionData?: any
    soltraderPenstionList: ListFrontEndInterface[]
}): React.ReactElement => {
    const {
        soleTraderId,
        companyAttachmentId,
        serviceName,
        documentBaseId,
        documentType,
        fetchData,
        soltraderPenstionList,
        pensionData,
    } = props
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [uploadFileList, setUploadFileList] = useState<string[]>([])
    const [selectedDocumentType, setSelectedDocumentType] = useState(11)
    const hasFetchedOnce = useRef(false)
    useEffect(() => {
        if (!hasFetchedOnce.current) {
            hasFetchedOnce.current = true
            return
        }
        GetSolderDropDownList(dispatch)
        hasFetchedOnce.current = false
    }, [])

    const handleSetFormData = (name: string, locations: string[]): void => {
        setUploadFileList(locations)
    }

    const handeleCompanDocumentSave = (): void => {
        void handeleDocumentSave()
    }
    const handeleDocumentSave = async (): Promise<void> => {
        try {
            await form.validateFields()
            const formdata = form.getFieldsValue()
            const documentBaseIds =
                documentBaseId === 0 ? selectedDocumentType : documentBaseId

            const convertedString = uploadFileList
                .map((item) => item.slice())
                .join(', ')

            if (documentType === '') {
                const datasss = pensionData?.filter(
                    (d: any) => d.documentBaseId === documentBaseIds
                )
                const savedata = {
                    companyAttachmentId: datasss.companyAttachmentId ?? 0,
                    companyTypeId: 1,
                    referenceId: soleTraderId,
                    referenceId2: 0,
                    documentBaseId: documentBaseIds ?? 0,
                    documentBaseName: serviceName ?? '',
                    attachmentPath:
                        serviceName === 'Pension'
                            ? convertedString
                            : (formdata.attachmentPath ?? ''),
                    corporateId: 0,
                    type: datasss.documentType ?? '',
                    ppExpiryDate: '',
                    dlExpiryDate: '',
                    prExpiryDate: '',
                }
                await SaveOfficerDocument(dispatch, savedata).then((result) => {
                    if (result !== null && result !== undefined) {
                        fetchData()
                        form.resetFields(['attachmentPath'])
                    }
                })
            } else {
                const savedata = {
                    companyAttachmentId: companyAttachmentId ?? 0,
                    companyTypeId: 2,
                    referenceId: soleTraderId,
                    referenceId2: 0,
                    documentBaseId: documentBaseId ?? 0,
                    documentBaseName: serviceName ?? '',
                    attachmentPath: convertedString ?? '',
                    corporateId: 0,
                    type: documentType ?? '',
                    ppExpiryDate: '',
                    dlExpiryDate: '',
                    prExpiryDate: '',
                }
                await SaveOfficerDocument(dispatch, savedata).then((result) => {
                    if (result !== null && result !== undefined) {
                        fetchData()
                        form.resetFields(['attachmentPath'])
                        window.scrollTo(0, 0)
                    }
                })
            }
        } catch (error) {}
    }

    const handleDocumentTypeChange = (value: number): void => {
        setSelectedDocumentType(value)
        form.resetFields(['attachmentPath'])
    }

    return (
        <div className={commontStyles.formWrapper}>
            <Form
                name="complex-form"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{
                    remember: true,
                }}
                layout={'vertical'}
                autoComplete="off"
                form={form}
                requiredMark={customizeRequiredMark}
            >
                {serviceName === 'Pension' ? (
                    <>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    label="Document Type"
                                    name="title"
                                    className={
                                        commontStyles.CorporteDocumentGeenreal
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please Select Document Type!',
                                        },
                                    ]}
                                >
                                    <Select
                                        allowClear
                                        placeholder="Please select"
                                        onChange={handleDocumentTypeChange}
                                        value={selectedDocumentType}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option?.label
                                                ?.toLowerCase()
                                                .includes(
                                                    input.toLowerCase()
                                                ) ?? false
                                        }
                                        options={soltraderPenstionList}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="attachmentPath"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please Attach Attachments!',
                                        },
                                    ]}
                                >
                                    <S3UploadMultiple
                                        name={'attachmentPath'}
                                        value={uploadFileList}
                                        setFormData={handleSetFormData}
                                        corporate={'Corporate'}
                                        corporateid={soleTraderId}
                                        documenttype={serviceName ?? ''}
                                        documentbaseId={documentBaseId ?? 0}
                                        memberpersonId={0}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <Row gutter={16}>
                        <Col span={24}>
                            <S3UploadMultiple
                                name={'attachmentPath'}
                                value={uploadFileList}
                                setFormData={handleSetFormData}
                                corporate={'Corporate'}
                                corporateid={soleTraderId}
                                documenttype={serviceName ?? ''}
                                documentbaseId={documentBaseId ?? 0}
                                memberpersonId={0}
                            />
                        </Col>
                    </Row>
                )}

                <Row gutter={16}>
                    <Col offset={20} span={2}>
                        <Tooltip title="Save Document">
                            <Button
                                type="primary"
                                onClick={handeleCompanDocumentSave}
                                className={`${
                                    serviceName !== 'Pension'
                                        ? commontStyles.savebuttonless
                                        : ''
                                }`}
                            >
                                <SaveOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

const mapStateToProps = (state: any): SolderServiceDocument => {
    return {
        documenttypeList: state.common.documenttypeList,
        soltraderPenstionList: state.initial.soltraderPenstionList,
    }
}

export default connect(mapStateToProps)(ServiceDocumentUpload)
